import { createApiCaller, SAGA_ACTIONS } from "src/_config";
// import { LoginReq, LoginWithOtpReq } from "src/_common/interfaces/ApiReqRes";
import { useApiCall } from "../common/appApiCallHook";

export function useUserApi() {
  const callApi = useApiCall();

  return {
    callLogin: createApiCaller(callApi, SAGA_ACTIONS.AUTH.LOGIN),
    callLoginWithOtp: createApiCaller(callApi, SAGA_ACTIONS.AUTH.LOGIN_WITH_OTP),
    callLoginWithEmail: createApiCaller(callApi, SAGA_ACTIONS.AUTH.LOGIN_WITH_EMAIL),
    callForgotPassword: createApiCaller(callApi, SAGA_ACTIONS.AUTH.FORGOT_PASSWORD),
    callResetPassword: createApiCaller(callApi, SAGA_ACTIONS.AUTH.RESET_PASSWORD),
    callRegistration: createApiCaller(callApi, SAGA_ACTIONS.AUTH.REGISTRATION),
    callUpdateUserProfile: createApiCaller(callApi, SAGA_ACTIONS.AUTH.UPDATE_PROFILE),
    callLogout: createApiCaller(callApi, SAGA_ACTIONS.AUTH.LOGOUT),
    callGetMe: createApiCaller(callApi, SAGA_ACTIONS.AUTH.DETAILS),
    callAutoLoginWithToken: createApiCaller(callApi, SAGA_ACTIONS.AUTH.AUTO_LOGIN),
    callUpdateDisplayName: createApiCaller(callApi, SAGA_ACTIONS.AUTH.UPDATE_DISPLAY_NAME),
    callUpdateDob: createApiCaller(callApi, SAGA_ACTIONS.AUTH.UPDATE_DOB),
    callCheckValidToken: createApiCaller(callApi, SAGA_ACTIONS.AUTH.CHECK_VALID_TOKEN),
    callSaveNotification: createApiCaller(callApi, SAGA_ACTIONS.AUTH.SAVE_NOTIFICATION),
    callCreateUpdateUserGame: createApiCaller(callApi, SAGA_ACTIONS.AUTH.CREATE_UPDATE_USER_GAME),
    callGetRegistrationFieldsData: createApiCaller(callApi, SAGA_ACTIONS.AUTH.REGISTRATION_FIELDS),
    callDeleteUser: createApiCaller(callApi, SAGA_ACTIONS.AUTH.DELETE_USER),
    callSaveUserPicks: createApiCaller(callApi, SAGA_ACTIONS.AUTH.SAVE_USER_PICKS),
  };
}
